module.exports = __webpack_public_path__ + "media/images/recruit/top/mv_men-cb31bb0705a166db993d42d23c422ac0.png";